import {Component, input} from '@angular/core';
import {ProgressBar} from 'primeng/progressbar';

export enum ProgressDashboardBoxType {
  TOTAL = 'TOTAL',
  COMPLETED = 'COMPLETED',
  PCT_COMPLETED = 'PCT_COMPLETED',
  NUM_CRITERIA = 'NUM_CRITERIA',
  NUM_SUB_CRITERIA = 'NUM_SUB_CRITERIA',
}

type IconConfig = {
  bgClass: string;
};

const ICON_CONFIG: Record<ProgressDashboardBoxType, IconConfig> = {
  [ProgressDashboardBoxType.TOTAL]: {
    bgClass: 'bg-[#00A4D6]/10',
  },
  [ProgressDashboardBoxType.COMPLETED]: {
    bgClass: 'bg-green-500/10',
  },
  [ProgressDashboardBoxType.PCT_COMPLETED]: {
    bgClass: 'bg-[#ff4f66]/10',
  },
  [ProgressDashboardBoxType.NUM_CRITERIA]: {
    bgClass: 'bg-blue-500/10',
  },
  [ProgressDashboardBoxType.NUM_SUB_CRITERIA]: {
    bgClass: 'bg-purple-500/10',
  },
};

@Component({
  selector: 'app-progress-dashboard-box',
  imports: [ProgressBar],
  templateUrl: './progress-dashboard-box.component.html',
})
export class ProgressDashboardBoxComponent {
  label = input.required<string>();
  value = input.required<number>();
  type = input.required<ProgressDashboardBoxType>();

  getIconConfig(): IconConfig {
    return ICON_CONFIG[this.type()];
  }
}
